import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { UIProvider } from "@/context/UIContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SellerApplicationModal from "@/components/SellerApplicationModal";
import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import ItineraryDetail from "@/pages/ItineraryDetail";
import Library from "@/pages/Library";
import Reader from "@/pages/Reader";
import InvitePage from "@/pages/InvitePage";
import SellerDashboard from "@/pages/SellerDashboard";
import Builder from "@/pages/Builder";
import AdminPanel from "@/pages/AdminPanel";
import CreatorProfile from "@/pages/CreatorProfile";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refunds from "@/pages/Refunds";
import Contact from "@/pages/Contact";
import RequestAccess from "@/pages/RequestAccess";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/itinerary/:slug" element={<ItineraryDetail />} />
      <Route path="/creator/:user_id" element={<CreatorProfile />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refunds" element={<Refunds />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/request-access" element={<RequestAccess />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
      <Route path="/library/:slug" element={<ProtectedRoute><Reader /></ProtectedRoute>} />
      <Route path="/seller" element={<ProtectedRoute requireSeller><SellerDashboard /></ProtectedRoute>} />
      <Route path="/seller/new" element={<ProtectedRoute requireSeller><Builder /></ProtectedRoute>} />
      <Route path="/seller/edit/:id" element={<ProtectedRoute requireSeller><Builder /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <UIProvider>
        <BrowserRouter>
          <AppRouter />
          <SellerApplicationModal />
          <Toaster position="top-center" theme="light" richColors />
        </BrowserRouter>
      </UIProvider>
    </AuthProvider>
  );
}

export default App;
